import type {
  PostMfaSetup,
  PostMfaVerifySetup,
  GetMfaStatus,
  PostMfaVerify,
  PostMfaRecovery,
  PostMfaReset,
  PostAuthReauth,
} from "@/server-types";
import { get, post } from "../request-helpers";
import { useCustomMutation } from "../custom-mutation";
import { useCustomQuery } from "../custom-query";

/**
 * GET /user/2fa/status
 */
export const useMfaStatus = (enabled = true) => {
  return useCustomQuery({
    queryKey: ["mfa-status"],
    queryFn: () => get<GetMfaStatus>("/user/2fa/status"),
    enabled,
  });
};

/**
 * POST /user/2fa/setup
 */
export const useMfaSetup = () => {
  return useCustomMutation({
    mutationKey: ["mfa-setup"],
    mutationFn: () => post<PostMfaSetup>("/user/2fa/setup"),
  });
};

/**
 * POST /user/2fa/verify-setup
 */
export const useMfaVerifySetup = () => {
  return useCustomMutation({
    mutationKey: ["mfa-verify-setup"],
    mutationFn: (body: PostMfaVerifySetup["body"]) =>
      post<PostMfaVerifySetup>("/user/2fa/verify-setup", body),
  });
};

/**
 * POST /user/2fa/verify
 */
export const useMfaVerify = () => {
  return useCustomMutation({
    mutationKey: ["mfa-verify"],
    mutationFn: (body: PostMfaVerify["body"]) =>
      post<PostMfaVerify>("/user/2fa/verify", body),
  });
};

/**
 * POST /user/2fa/recovery
 */
export const useMfaRecovery = () => {
  return useCustomMutation({
    mutationKey: ["mfa-recovery"],
    mutationFn: (body: PostMfaRecovery["body"]) =>
      post<PostMfaRecovery>("/user/2fa/recovery", body),
  });
};

/**
 * POST /user/2fa/reset
 */
export const useMfaReset = () => {
  return useCustomMutation({
    mutationKey: ["mfa-reset"],
    mutationFn: (body: PostMfaReset["body"]) =>
      post<PostMfaReset>("/user/2fa/reset", body),
  });
};

/**
 * POST /user/auth/reauth
 */
export const useAuthReauth = () => {
  return useCustomMutation({
    mutationKey: ["auth-reauth"],
    mutationFn: () => post<PostAuthReauth>("/user/auth/reauth", {}),
  });
};
